import React from "react";
const Wave = ({
  color,
  style,
  className,
}: {
  color: string;
  style?: any;
  className?: string;
}) => (
  <svg
    style={style}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 344 13"
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M0 0v8.62c0 2.54 2.958 3.93 4.914 2.31L18.105 0H0zm18.105 0 6.485 10.744c1.166 1.933 3.97 1.933 5.137 0L36.21 0H18.105zm18.106 0 6.482 10.744h.002c1.166 1.933 3.97 1.933 5.137 0L54.316 0H36.211zm18.105 0 6.485 10.744c1.167 1.933 3.97 1.933 5.136 0L72.42 0H54.316zm18.106 0 6.482 10.744c1.167 1.933 3.972 1.933 5.139 0L90.525 0H72.422zm18.103 0 6.485 10.744c1.167 1.933 3.97 1.933 5.136 0L108.633 0H90.525zm18.108 0 6.482 10.744c1.166 1.933 3.972 1.933 5.139 0L126.736 0h-18.103zm18.103 0 6.485 10.744c1.167 1.933 3.97 1.933 5.136 0L144.842 0h-18.106zm18.106 0 6.484 10.744c1.167 1.933 3.97 1.933 5.137 0L162.947 0h-18.105zm18.105 0 6.485 10.744c1.166 1.933 3.97 1.933 5.136 0L181.053 0h-18.106zm18.106 0 6.484 10.744c1.166 1.933 3.97 1.933 5.137 0L199.158 0h-18.105zm18.105 0 6.485 10.744c1.167 1.933 3.97 1.933 5.136 0L217.264 0h-18.106zm18.106 0 6.482 10.744c1.167 1.933 3.973 1.933 5.139 0L235.367 0h-18.103zm18.103 0 6.487 10.744c1.166 1.933 3.97 1.933 5.136 0L253.475 0h-18.108zm18.108 0 6.482 10.744c1.167 1.933 3.972 1.933 5.139 0L271.578 0h-18.103zm18.103 0 6.485 10.744c1.166 1.933 3.97 1.933 5.136 0L289.684 0h-18.106zm18.106 0 6.484 10.744c1.167 1.933 3.97 1.933 5.137 0L307.789 0h-18.105zm18.105 0 6.484 10.744c1.166 1.933 3.97 1.933 5.137 0L325.895 0h-18.106zm18.106 0 13.19 10.93c1.957 1.62 4.915.23 4.915-2.31V0h-18.105z"
    />
  </svg>
);

export default Wave;
